function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M45.13 62.905c-1.107.214-2.294.39-3.544.523m-11.171 0c-6.957-.74-11.97-2.824-11.97-5.28 0-1.907 3.024-3.59 7.633-4.594m19.844 0c4.61 1.004 7.632 2.687 7.632 4.594 0 .81-.545 1.58-1.526 2.275M44.89 43.465c-3.044 4.23-6.242 7.801-8.028 9.706a1.867 1.867 0 01-2.791-.048C30.218 48.692 19.543 35.54 19.543 25.85c0-9.543 7.39-17.28 16.505-17.28 8.512 0 15.518 6.746 16.41 15.41m-3.154 12.48a38.569 38.569 0 001.45-3.03m1.526-4.851c-.056.298-.122.599-.194.901",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeLinecap: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M44.777 25.029A8.777 8.777 0 1136 16.252",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgPoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "/img/point.svg";
export { SvgPoint as ReactComponent };